import {
  Box,
  Button,
  Divider,
  HStack,
  Icon,
  IconButton,
  Spinner,
  Text,
  VStack,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { FaAngleRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { securedAxiosInstance } from '../../api/axios';
import Card from '../Card';

const BoxUpdates = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [latestUpdates, setLatestUpdates] = useState([]);
  useEffect(() => {
    const getLatestDocs = async () => {
      setIsLoading(true);
      const res = await securedAxiosInstance.get('articles/latest');
      setLatestUpdates(res.data);
      setIsLoading(false);
    };

    getLatestDocs();
  }, []);
  return (
    <Box w={'full'} h={'full'}>
      <Card
        mx={'auto'}
        flex={'1'}
        flexGrow={'1'}
        h={'full'}
        overflowY={'hidden'}
      >
        <VStack align={'start'} h={'full'}>
          <HStack mb={'4'}>
            <Text fontWeight={'bold'} fontSize="md" w="full">
              4Boxes Updates
            </Text>
            <Icon viewBox="0 0 200 200" color="primary">
              <path
                fill="currentColor"
                d="M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0"
              />
            </Icon>
          </HStack>
          <Box h={'full'} pb={'6'} flex={1} w={'full'}>
            <Scrollbars>
              <VStack
                overflowY="hidden"
                flex={1}
                w={'full'}
                divider={<Divider />}
              >
                {isLoading ? (
                  <Spinner color="primary" />
                ) : latestUpdates.length > 0 ? (
                  latestUpdates.map((update, i) => (
                    <HStack
                      w={'full'}
                      px={'3'}
                      justifyContent={'space-between'}
                      key={update.id}
                    >
                      <Text w={'full'} fontSize={'14px'} py={4}>
                        {update.title}
                      </Text>
                      <IconButton
                        variant={'outline'}
                        size="xs"
                        border={'1.5px solid'}
                        borderColor={'lightGray.500'}
                        p={0}
                        color="lightGray.500"
                        _hover={{ color: 'primary', borderColor: 'primary' }}
                        icon={<FaAngleRight />}
                        as={'a'}
                        href={`https://learn.4boxes.com.au/${update.slug}`}
                        target={'_blank'}
                        rel={'noopener noreferrer'}
                      />
                    </HStack>
                  ))
                ) : (
                  <Text>No updates yet.</Text>
                )}
              </VStack>
            </Scrollbars>
          </Box>
          <Button
            background={'primaryOpaque'}
            color={'primary'}
            w={'full'}
            as={'a'}
            href={`https://learn.4boxes.com.au/`}
            target={'_blank'}
            rel={'noopener noreferrer'}
          >
            View More
          </Button>
        </VStack>
      </Card>
    </Box>
  );
};

export default BoxUpdates;
